import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardBCEIP from './pages/DashboardBCEIP';
import DashboardEntreprise from './pages/DashboardEntreprise';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard-bceip" element={<DashboardBCEIP />} />
          <Route path="/dashboard-entreprise" element={<DashboardEntreprise />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
